import React from 'react';
import { Link } from 'react-router-dom';

const Technology = () => {
    return (
        <main className="min-h-screen bg-[#050914] text-white">

            <section className="relative overflow-hidden pt-36 pb-28">
                <div className="absolute inset-0 pointer-events-none">
                    <div className="absolute top-20 left-1/2 -translate-x-1/2 w-[800px] h-[500px] rounded-full bg-[#3157ff]/[0.05] blur-[160px]" />
                </div>

                <div className="relative z-10 max-w-[1200px] mx-auto px-8">

                    <div className="flex items-center gap-3 text-[11px] tracking-[0.28em] text-neutral-500 mb-7">
                        <span className="w-8 h-px bg-neutral-600" />
                        TECHNOLOGY
                    </div>

                    <h1 className="max-w-[900px] text-[48px] sm:text-[64px] lg:text-[76px] leading-[1] font-semibold tracking-[-0.045em]">
                        From brain signals
                        <br />
                        <span className="text-neutral-500">
              to useful intelligence.
            </span>
                    </h1>

                    <p className="mt-8 max-w-[700px] text-[17px] leading-[1.7] text-neutral-400">
                        FroCort combines EEG and other wearable signals with machine
                        learning to build toward real-time understanding of changes in
                        cognitive state.
                    </p>

                    <div className="mt-10">
                        <Link
                            to="/research"
                            className="inline-flex items-center rounded-full border border-white/15 px-6 py-3.5 text-[14px] text-neutral-200 hover:bg-white/5 transition-colors"
                        >
                            See our research
                        </Link>
                    </div>

                </div>
            </section>

            <section className="border-t border-white/10 py-28">
                <div className="max-w-[1200px] mx-auto px-8">

                    <div className="grid md:grid-cols-3 gap-px bg-white/10 rounded-[28px] overflow-hidden border border-white/10">

                        <div className="bg-[#050914] p-8 sm:p-10 min-h-[280px]">
                            <div className="text-[11px] tracking-[0.24em] text-neutral-600">
                                01
                            </div>

                            <h2 className="mt-14 text-[25px] font-medium">
                                Sense
                            </h2>

                            <p className="mt-4 text-[14px] leading-7 text-neutral-500">
                                Capture signals from the brain and body through wearable
                                hardware.
                            </p>
                        </div>

                        <div className="bg-[#050914] p-8 sm:p-10 min-h-[280px]">
                            <div className="text-[11px] tracking-[0.24em] text-neutral-600">
                                02
                            </div>

                            <h2 className="mt-14 text-[25px] font-medium">
                                Understand
                            </h2>

                            <p className="mt-4 text-[14px] leading-7 text-neutral-500">
                                Use machine learning to identify patterns associated with
                                changes in mental state.
                            </p>
                        </div>

                        <div className="bg-[#050914] p-8 sm:p-10 min-h-[280px]">
                            <div className="text-[11px] tracking-[0.24em] text-neutral-600">
                                03
                            </div>

                            <h2 className="mt-14 text-[25px] font-medium">
                                Respond
                            </h2>

                            <p className="mt-4 text-[14px] leading-7 text-neutral-500">
                                Turn that understanding into experiences that can adapt to the
                                person.
                            </p>
                        </div>

                    </div>

                </div>
            </section>

        </main>
    );
};

export default Technology;